// extracted by mini-css-extract-plugin
export default {"searchInput":"fQZwc1","heading":"oxwSr2","searchResults":"sqvISh","noSearch":"Bue2zP","noResults":"PCuax1","searchResults--mobile":"oug5KK"};